angular.module('app.core', []);